export default __webpack_public_path__ + "static/media/Garden.3e65b5d9.jpg";